import React, { ReactElement, ChangeEvent } from "react";
import styled from 'styled-components';
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

interface FilterDropdownProps {
  handleChangeFilter: (e: ChangeEvent<HTMLSelectElement>) => void;
  selectedFilter: string;
  filterOptions: string[][];
}

const StyledFilterDropdown = styled.div`
  padding: 0px 20px 20px 50px;
`

export default class FilterDropdown extends React.Component<FilterDropdownProps> {
  render(): ReactElement {
    return (
      <StyledFilterDropdown className="filter">
        <span>{i18n.translate("awards.claimable_awards.filter")}&nbsp;</span>
        <select
          value={this.props.selectedFilter}
          onChange={this.props.handleChangeFilter}
          name="filter"
          id="filter"
          className="filterable-table-select"
        >
          {this.renderFilterOptions()}
        </select>
      </StyledFilterDropdown>
    );
  }

  renderFilterOptions = (): ReactElement[] => {
    return this.props.filterOptions.map((option, i) => {
      return (
        <option value={option[1]} key={i}>
          {option[0]}
        </option>
      );
    });
  };
}
